import React from 'react';
import InputMask from 'react-input-mask';

import { AUTOCOMPLETE_ADDRESS, AUTOCOMPLETE_POST_CODE, COUNTRY, DATE, DROP_BOX, PHONE_COUNTRY, SBP_DROP_BOX, TEXT } from 'apps/auth/constants/FieldType';
import { LOGIN_REGISTRATION_FORM_NAME, SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';
import { getInputMode, getPlaceholderRule, getSeparatorsCount, isMaskPattern, padMaskPattern } from 'apps/auth/helpers/fieldMask';
import { toUpperCase } from 'apps/auth/helpers/utils';

import InputBase from './InputBase';
import { notValidateUpdateValue } from './utils';

const InputText = (props) => {
    const field = props.field;
    if (field.value === null) {
        field.value = '';
    }

    const hasMaxLength = props.setMaxLength && field.maxLength;

    const onChange = (e) => {
        e.preventDefault();
        const field = props.field;
        if (!field.isReadOnly) {
            const value = e.target.value ? toUpperCase(e.target.value) : '';
            notValidateUpdateValue(props.formName, value, field, props.changeFormField).then(() => {
                if (props.onChangeHandler) {
                    props.onChangeHandler(value, field.name);
                }
            });
        }
    };

    const setAutocomplete = () => {
        const fieldName = field?.name;
        let autocompleteValue = 'off';
        if (props.formName === LOGIN_REGISTRATION_FORM_NAME) {
            switch (fieldName) {
                case 'name':
                    autocompleteValue = 'given-name';
                    break;
                case 'name_f':
                    autocompleteValue = 'family-name';
                    break;
                case 'address':
                    autocompleteValue = 'street-address';
                    break;
                case 'email':
                    autocompleteValue = 'email';
                    break;
                default:
                    autocompleteValue = 'disabled';
            }
        }
        if (props.formName === SEND_FORM_NAME) {
            autocompleteValue = `section-${field.name} off`;
        }
        return autocompleteValue;
    };

    if (isMaskPattern(field.mask)) {
        const separatorsCount = hasMaxLength ? getSeparatorsCount(field.value, field.mask) : 0;
        return (
            <InputMask
                mask={padMaskPattern(field.mask)}
                maskChar={null}
                formatChars={{ '#': getPlaceholderRule(field.mask, field.checkRegexp) }}
                id={props.id ? props.id : field.name}
                name={field.canonicalPath ? field.canonicalPath : field.name}
                value={props.customValue || field.value}
                type={field.type}
                className={props.isNewInput ? null : 'field field-duo'}
                autoComplete={setAutocomplete()}
                readOnly={props.isReadOnly || field.isReadOnly || props.isNativeReadOnly}
                disabled={props.isReadOnly || field.isReadOnly}
                autoFocus={props.focus}
                onClick={props.onClick}
                onFocus={props.onFocus}
                onChange={props.onChange}
                onBlur={props.onBlur}
            >
                {(inputProps) => (
                    <input
                        {...inputProps}
                        maxLength={hasMaxLength ? +field.maxLength + separatorsCount : null}
                        inputMode={getInputMode(field.checkRegexp, field.mask)}
                    />
                )}
            </InputMask>
        );
    }

    return (
        <input
            id={props.id ? props.id : field.name}
            name={field.canonicalPath ? field.canonicalPath : field.name}
            maxLength={hasMaxLength ? field.maxLength : ''}
            value={props.customValue || field.value}
            type={field.type}
            inputMode={getInputMode(field.checkRegexp, field.mask)}
            className={props.isNewInput ? null : 'field field-duo'}
            autoComplete={setAutocomplete()}
            readOnly={props.isReadOnly || field.isReadOnly || props.isNativeReadOnly}
            disabled={props.isReadOnly || field.isReadOnly}
            autoFocus={props.focus}
            onClick={props.onClick}
            onFocus={props.onFocus}
            onChange={props.upperCase ? onChange : props.onChange}
            onBlur={props.onBlur}
        />
    );
};

InputText.propTypes = inputPropType([
    COUNTRY,
    'tel',
    'email',
    'number',
    'upload_doc',
    'password',
    'search',
    'digital',
    SBP_DROP_BOX,
    TEXT,
    'short_text',
    'url',
    DATE,
    'hidden',
    DROP_BOX,
    AUTOCOMPLETE_ADDRESS,
    AUTOCOMPLETE_POST_CODE,
    PHONE_COUNTRY,
]);

export default InputBase(InputText);
